import React, { useState, useEffect } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetails, updateUserDetails } from "../actions/userActions";
import Loader from "../components/Loader";
import Message from "../components/Message";
import Navbar from "../components/Navbar";
import { USER_UPDATE_PROFILE_RESET } from "../constants/userConstants";
import "../App.css";

const ProfileScreen = ({ location, history }) => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [contact, setContact] = useState("");
  const [address, setAddress] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState(null);

  const dispatch = useDispatch();

  const userDetails = useSelector((state) => state.userDetails);
  const { loading, error, user } = userDetails;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const userUpdateProfile = useSelector((state) => state.userUpdateProfile);
  const { success } = userUpdateProfile;

  useEffect(() => {
    if (!userInfo) {
      history.push("/login");
    } else {
      if (!user.username || !user || success) {
        // console.log(success);
        dispatch({ type: USER_UPDATE_PROFILE_RESET });
        dispatch(getUserDetails("profile"));
      } else {
        setUsername(user.username);
        setEmail(user.email);
        setAddress(user.address);
        setContact(user.contact);
      }
    }
  }, [dispatch, history, userInfo, user, success]);

  const submitHandler = (e) => {
    e.preventDefault();

    // if (!username) {
    //   return setMessage("Invalid username");
    // }
    // if (typeof username !== "undefined") {
    //   var pattern = new RegExp(/^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/);
    //   if (!pattern.test(username)) {
    //     return setMessage("Please enter valid username");
    //   } else if (username.length >= 25) {
    //     return setMessage("Max username length is 25");
    //   }
    // }
    // if (!email) {
    //   return setMessage("Invalid Email");
    // }

    // if (typeof email !== "undefined") {
    //   var pattern = new RegExp(
    //     /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    //   );
    //   if (!pattern.test(email)) {
    //     return setMessage("Please enter valid email address");
    //   }
    // }

    // if (!contact) {
    //   return setMessage("Please enter your contact number");
    // }

    // if (typeof contact !== "undefined") {
    //   var pattern = new RegExp(/^[0-9\b]+$/);
    //   if (!pattern.test(contact)) {
    //     return setMessage("Please enter only number");
    //   } else if (contact.length > 10 && contact.length < 10) {
    //     // console.log(contact.length);
    //     return setMessage("Please enter valid contact number");
    //   }
    // }
    if (password !== confirmPassword) {
      setMessage("Password do not match");
    } else {
      dispatch(
        updateUserDetails({
          id: user._id,
          username,
          email,
          contact,
          address,
          password,
        })
      );
    }
  };

  return (
    <>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <div className="tw-w-5/6 md:tw-w-1/2 tw-my-8 tw-mx-auto tw-flex tw-justify-center tw-items-center tw-p-1 tw-border-1 tw-rounded-lg tw-shadow-2xl">
        <Row className="tw-w-full tw-px-2">
          <Col>
            <h3 className="tw-font-nunito sm:tw-text-3xl tw-text-2xl tw-font-bold tw-my-4 tw-text-center">
              Update Profile
            </h3>
            {message && <Message variant="danger">{message}</Message>}
            {error && <Message variant="danger">{error}</Message>}
            {success && alert("Profile updated") && (
              <Message variant="success">Profile updated</Message>
            )}
            {loading && <Loader />}
            <Form onSubmit={submitHandler} className="tw-font-nunito">
              <Form.Group className="tw-py-2" controlId="name">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="name"
                  placeholder="Enter Name"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="tw-py-2" controlId="email">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="tw-py-2" controlId="contact">
                <Form.Label>Contact</Form.Label>
                <Form.Control
                  type="contact"
                  placeholder="Enter Contact"
                  value={contact}
                  onChange={(e) => setContact(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="tw-py-2" controlId="address">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="address"
                  placeholder="Enter Address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="tw-py-2" controlId="password">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <Form.Group className="tw-py-2" controlId="confirmPassword">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Confirm password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                ></Form.Control>
              </Form.Group>
              <br />
              <Button
                type="submit"
                className="tw-mb-8 tw-px-16 tw-block tw-mx-auto tw-transition tw-duration-700 tw-ease-in-out tw-transform hover:-tw-translate-y-1 hover:tw-scale-11 myButton"
              >
                Update
              </Button>
            </Form>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ProfileScreen;
